module.exports = __webpack_public_path__ + "img/sidebar_3liga_202627.b89293f3.png";